<script setup lang="ts">
import type { CookieTableData } from '~/utils/crystallize/pieces'

defineProps<{
  data: CookieTableData
}>()
</script>

<template>
  <section class="flex flex-col gap-m">
    <h2 v-if="data.title" class="title-m" v-text="data.title" />

    <CrystallizeRichText v-for="(block, i) in data.description" :key="i" :block="block" />

    <div class="cky-audit-table-element" />
  </section>
</template>

<style scoped>
.cky-audit-table-element:empty {
  display: none;
}
</style>
